import { render, staticRenderFns } from "./ProcessProjectTable.vue?vue&type=template&id=2bec38fe&"
import script from "./ProcessProjectTable.vue?vue&type=script&lang=js&"
export * from "./ProcessProjectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports